import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PageQuerySchema } from '../pagination';

export const ReleaseAuditEventSchema = z.object({
  id: z.string().uuid(),
  actorUserId: z.string().uuid().nullable(),
  /** Display name of the actor; null for system actions (e.g. webhooks). */
  actorName: z.string().nullable(),
  action: z.string(),
  entityType: z.string(),
  entityId: z.string(),
  detail: z.record(z.unknown()),
  createdAt: z.string(),
});
export type ReleaseAuditEventItem = z.infer<typeof ReleaseAuditEventSchema>;

export const ListReleaseAuditQuerySchema = PageQuerySchema.pick({
  limit: true,
  cursor: true,
}).extend({
  entityType: z.string().optional(),
  entityId: z.string().optional(),
});

export const listReleaseAudit = defineEndpoint({
  method: 'GET',
  path: '/v1/release-audit',
  params: z.object({}),
  query: ListReleaseAuditQuerySchema,
  body: z.undefined(),
  response: z.object({
    data: z.array(ReleaseAuditEventSchema),
    meta: z.object({
      nextCursor: z.string().nullable(),
      hasMore: z.boolean(),
      limit: z.number().int(),
    }),
  }),
});
